import React, {useCallback} from 'react'
import '../../assets/css/project.scss';
import InputMask from 'react-input-mask';
import { StickyContainer, Sticky } from 'react-sticky';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBallotCheck,
    faBoxCheck,
    faChevronLeft,
    faChevronRight,
    faClock,
    faEnvelope,
    faPhone,
    faTimesCircle
} from "@fortawesome/pro-regular-svg-icons";
import Actions from "../../helpers/actions";
import Select from "react-select";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Functions from "../../helpers/functions";
import ContentLoader from "react-content-loader";


import Locale from '../../assets/languages/locale.json';
import Highcharts from 'highcharts';
import addHighchartsMore from 'highcharts/highcharts-more';
import {
    HighchartsChart, Chart, withHighcharts, XAxis, YAxis, Tooltip, Title, Subtitle, Legend,ColumnSeries,PieSeries, LineSeries, SplineSeries,ColumnRangeSeries, AreaSeries,AreaSplineSeries, Annotation
} from 'react-jsx-highcharts';
import ReactToPrint from "react-to-print";
import {Line} from "rc-progress";
import {FormattedDate, FormattedMessage, FormattedRelativeTime} from "react-intl";
import TipBox from "../tipBox";
import ReactPaginate from "react-paginate";

require("highcharts/modules/annotations")(Highcharts);
addHighchartsMore(Highcharts);


class project extends React.Component {
    constructor(props) {
        super(props);


        var startDate = new Date(2020,5,10);
        var projectStatus = [];
        var projectStatusDates = [];

        var actions = {}
        actions[new Date(2020,5,11).getTime()] = {progress:0,name:"Offer sended",color:"#BF0B23"};
        actions[new Date(2020,5,12).getTime()] = {progress:10,name:"Offer accepted",color:"#029546"};
        actions[new Date(2020,5,16).getTime()] = {progress:20,name:"Order created",color:"#f44336"};
        actions[new Date(2020,5,21).getTime()] = {progress:40,name:"Production complete",color:"#cfe41d"};
        actions[new Date(2020,5,25).getTime()] = {progress:100,name:"Shipped & completed",color:"#1ecaca"};

        var progress = 0;

        for(var i =0;i<=14;i++){
            startDate.setDate(startDate.getDate() + 1);
            projectStatusDates.push([Functions.getFormattedDate(startDate,"DD MMM YYYY")]);

            if(typeof actions[startDate.getTime()] != "undefined"){
                progress = actions[startDate.getTime()].progress;
                projectStatus.push({
                    y:progress, color: actions[startDate.getTime()].color,name:actions[startDate.getTime()].name,
                    marker: {
                        enabled: true,
                        symbol: 'circle',
                        radius: 6
                    }
                });
            } else {
                projectStatus.push({
                    y:progress,name:"Nothing change",
                    marker: {
                        enabled: false
                    }
                });
            }
        }



        this.state = {
            contentAvaliable:true, // TODO Change false
            data: this.props.data,
            tabIndex:0,

            projectStatus:projectStatus,
            projectStatusDates:projectStatusDates,
        };
    }
    componentDidMount(){
        setTimeout(()=>{
            this.setState({contentAvaliable:true})
        },2000)

    }
    componentWillReceiveProps(nextProps){
        if(nextProps.data["done"] == true && !this.state.contentAvaliable){
            this.setState({
                offerName:nextProps.data.offerName,
                brand:nextProps.data.brand,
                customer:nextProps.data.customer,
                model:nextProps.data.model,
                type:nextProps.data.type,
            });
        }
    }
    renderContent(){
        if(this.state.contentAvaliable){
            return(
                <Tabs style={{height:(window.innerHeight - 102)+"px"}} selectedIndex={this.state.tabIndex} onSelect={(tabIndex) => {
                    this.setState({ tabIndex },()=>{
                        setTimeout(()=>{
                            //window.scrollTo(0, this.contentView.offsetTop)
                        },3000)
                    });
                }}>
                    <TabList>
                        <Tab>Summary</Tab>
                        <Tab>Activities</Tab>
                        <Tab>Offer History</Tab>
                        <Tab>Order Updates</Tab>
                        <Tab>Uygunsuzluks</Tab>
                    </TabList>
                    <div className={"container"} ref={(ref)=>{this.contentView = ref;}}>
                        <TabPanel>
                            <div style={{marginTop:10}}>
                                <div className={"row"}>
                                    <div className={"columns small-12"}>
                                        <div className={"columns small-12 block"}>
                                            <div className={"row"}>
                                                <div className={"columns small-12 medium-4"}>
                                                    <div className="progress">
                                                        <b>Project Status</b>
                                                        <p>Currently project progress status</p>
                                                        <div className={"wrapper"}>
                                                            <div className={"count"}>Completed <small>%100</small></div>
                                                            <Line percent="100" strokeWidth="3" strokeColor="#7bb5ec" trailWidth={3} trailColor="#e6e6e6"/>
                                                        </div>
                                                        <div className="text">
                                                            <a href="#a" className="action link">Show activities <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"columns small-12 medium-4"}>
                                                    <div className="progress">
                                                        <b>Uygunsuzluk Status</b>
                                                        <p>
                                                            Total created reports
                                                        </p>
                                                        <div className={"wrapper"}>
                                                            <div className={"count"}>12 / 21<small>%88</small></div>
                                                            <Line percent="88" strokeWidth="3" strokeColor="#7bb5ec" trailWidth={3} trailColor="#e6e6e6"/>
                                                        </div>
                                                        <div className="text">
                                                            <a href="#a" className="action link">Show reports <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"columns small-12 medium-4"}>
                                                    <div className="progress">
                                                        <b>Remaining Time</b>
                                                        <p>Remaining time before delivery</p>
                                                        <div className={"wrapper"}>
                                                            <div className={"count"}>2 Days passed <small>%100</small></div>
                                                            <Line percent="100" strokeWidth="3" strokeColor="indianred" trailWidth={3} trailColor="#e6e6e6"/>
                                                        </div>
                                                        <div className="text">
                                                            <a href="#a" className="action link">Show activities <FontAwesomeIcon icon={faChevronRight} size="xs"/></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"columns small-12 block"}>
                                        <HighchartsChart plotOptions={{
                                            line:{

                                                marker: {
                                                    lineWidth: 1
                                                },
                                                tooltip:{
                                                    crosshairs:true
                                                },
                                            }
                                        }}>
                                            <Chart height={400} backgroundColor={"transparent"} dateTime={Locale.tr.dateTime} min={Date.UTC(2020,5,10)} max={Date.UTC(2020,6,14)} inverted={false}/>

                                            <Legend />

                                            <Tooltip
                                                crosshairs={true}
                                                shared={true}
                                                valueSuffix="%"
                                            />

                                            <XAxis id="myXaxis" tickInterval={1}  categories={this.state.projectStatusDates} endOnTick={false} maxPadding={0} labels={{
                                                formatter: function() {
                                                    var date = this.value.toString().split(',')[0];
                                                    date = Functions.getFormattedDate(date,"DD / MM");
                                                    return date;
                                                }
                                            }} plotBands={[
                                                {
                                                    color: 'rgba(244, 67, 54, 0.5)',
                                                    width: 5,
                                                    value: 12
                                                }
                                            ]} crosshair={{
                                                width: 20,
                                                color: 'rgba(204, 214, 235, 0.25)'
                                            }}>
                                                <XAxis.Title>Days</XAxis.Title>
                                            </XAxis>

                                            <YAxis id="mxYaxis">
                                                <YAxis.Title margin={20} marginLeft={0}>Progress</YAxis.Title>
                                                <SplineSeries color={"rgba(61, 145, 255)"} fillColor={"rgba(61, 145, 255,0.8)"} name="Progress" data={this.state.projectStatus} />
                                            </YAxis>
                                        </HighchartsChart>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div id={"activity"}>
                                <div className={"columns small-12 block transparent"}>
                                    <div className="list">
                                        <div className={"container"}>
                                            <ul>
                                                <li className={"line"}></li>
                                                {this.renderActivities()}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel>
                            456
                        </TabPanel>
                        <TabPanel>
                            123
                        </TabPanel>
                        <TabPanel>
                            123
                        </TabPanel>
                    </div>
                </Tabs>
            )
        } else {
            return(
                <div style={{height:"100%"}}>
                    <ContentLoader
                        height={40}
                    >
                        <rect x="5" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="90" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="180" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="270" y="5" rx="4" ry="4" width="80" height="8" />
                        <rect x="330" y="5" rx="4" ry="4" width="70" height="8" />
                    </ContentLoader>
                    <ContentLoader
                        height={140}
                    >
                        {this.renderShimmers()}
                    </ContentLoader>
                </div>
            )
        }
    }
    renderShimmers(){
        var shimmers = [{},{},{},{},{},{},{},{},{},{}];
        return shimmers.map((data,i)=>{
            return(
                <rect x="5" y={(i * 16)} rx="4" ry="4" width="395" height="10" />
            );
        })
    }
    render(){
        return (
            <StickyContainer>
                <div id={"projectDetail"}>
                    <div className={"header row"}>
                        <div className={"columns shrink"}>
                            <div className={"logo"}>
                                <img src={"/assets/images/exampleCustomer.png"}/>
                            </div>
                        </div>
                        <div className={"columns shrink"}>
                            <div className={"title"}>
                                British Petrol - LPG Trailer - DY23344415
                            </div>
                        </div>
                        <div className={"columns"}>

                        </div>
                        <div className={"columns shrink"}>
                            <FontAwesomeIcon className={"close"} icon={faTimesCircle} size="x2" onClick={()=>{
                                this.setState({contentAvaliable:true},()=>{
                                    Actions.emit("closeSidePanel");
                                })
                            }}/>
                        </div>
                    </div>
                    {this.renderContent() }
                </div>
            </StickyContainer>
        );
    }
    async createOrder(){

    }

    renderIcon(type){
        var icons = [<FontAwesomeIcon icon={faPhone} size="lg"/>,<FontAwesomeIcon icon={faEnvelope} size="lg"/>,<FontAwesomeIcon icon={faBoxCheck} size="lg"/>,<FontAwesomeIcon icon={faBallotCheck} size="lg"/>]
        return <span className={"type"+type}>{icons[type]}</span>;
    }
    renderActivities(){
        var data = [
            {type:0,"description":"{member} numaralı proje teklifi onayladı"},
            {type:1,"description":"{member} numaralı ürün boya kalite kontrolü yapıldı"},
            {type:1,"description":"{member} numaralı ürün kaynak kalite kontrolü yapıldı"},
            {type:2,"description":"{member} numaralı ürün son kontroller onaylandı"},
            {type:3,"description":"{member} iş emri formu oluşturuldu"},
            {type:3,"description":"{member} iş emri formu oluşturuldu"},
            {type:3,"description":"{member} iş emri formu oluşturuldu"},
            {type:3,"description":"{member} iş emri formu oluşturuldu"},
            {type:3,"description":"{member} iş emri formu oluşturuldu"},
            {type:3,"description":"{member} iş emri formu oluşturuldu"},
            {type:3,"description":"{member} iş emri formu oluşturuldu"},
            {type:3,"description":"{member} iş emri formu oluşturuldu"},
        ];
        return data.map((data,key)=>{

            return(
                <li className={"row align-middle user"} key={"u_"+key}>
                    <div className={"columns name shrink"}>
                        <div className={"title"}>
                            <div className={"row collapse"}>
                                <div className={"columns shrink"}>
                                    <img className="image transition" src={Functions.fakeProfileImage()}/>
                                </div>
                                <div className={"columns"}>
                                    <a onClick={()=>{
                                        this.props.openSidePanel("users",3)
                                    }}><b>Ahmet Yusuf Besim</b></a>
                                    <small>Kalite Kontrol</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"columns shrink noPaddingLeft"}>
                        <div className={"action"}>
                            {this.renderIcon(data.type)}
                        </div>
                    </div>
                    <div className={"columns description"}>
                        <b>
                            <FormattedMessage
                                id="message"
                                defaultMessage={data.description}
                                values={{
                                    member: <a href='#'>DY 123 551 123</a>,
                                }}
                            />
                        </b>
                        <small>
                            <TipBox attachment={"bottom center"} element={()=>{
                                return(
                                    <span>
                                        <FontAwesomeIcon  icon={faClock} size="lg"/> <FormattedRelativeTime value={((new Date().getTime() - (60*3)) - new Date().getTime())} numeric="auto" updateIntervalInSeconds={10} />
                                    </span>
                                )
                            }} content={()=>{
                                return(
                                    <p className={"tipBoxWrapper small"}>
                                        <FormattedDate
                                            value={new Date(1459832991883)}
                                            year="numeric"
                                            month="long"
                                            day="2-digit"
                                        />
                                    </p>
                                )
                            }}/>
                        </small>
                    </div>
                </li>
            );
        });
    }
}

export default withHighcharts(project, Highcharts);
